// extracted by mini-css-extract-plugin
export var cardGroup = "CardGroup-module--cardGroup--3d088";
export var cdsAssistiveText = "CardGroup-module--cds--assistive-text--9e1c6";
export var cdsVisuallyHidden = "CardGroup-module--cds--visually-hidden--b300f";
export var hideFeedback = "CardGroup-module--hide-feedback--083fb";
export var showFeedback = "CardGroup-module--show-feedback--50d93";
export var skeleton = "CardGroup-module--skeleton--69473";